// Returns action creators for each categories action type
import { SET_HOMEPAGE_CATEGORIES, SET_HOMEPAGE_CATEGORY } from "../actionTypes";

// Action creators for homepage categories lookups slice
export const setHomepageCategories = (categories) => {
    return { type: SET_HOMEPAGE_CATEGORIES, payload: categories };
};
// Action creators for homepage category selection
export const setHomepageCategory = (category, data, team) => {
    return { type: SET_HOMEPAGE_CATEGORY, payload: [category, data, team] };
};
